import ActiveRecord from './active_record/base'
import * as API from '../../requests'
import {backend} from '../../backend'
import webUtils from '@eitje/utils'
import _ from 'lodash'

const untangleRecMap = ({resource_map}) => {
	let ordered = _.mapValues(_.groupBy(resource_map, 'kind'), arrOfItems => arrOfItems.map(i => i.resource_id))
	ordered = _.mapKeys(ordered, (value, key) => `${webUtils.camelToSnake(key)}_ids`.substring(1)) // hack cuz camelToSnake cant handle Pascal
	return ordered
}

const handleTopicResponse = res => {
	const {items = []} = res.data || {}
	API.createLocal('topics', items)
}

class Topic extends ActiveRecord {
	static tableName = 'topics'
	static defaultJoins = ['infos', 'quizItems']
	static sort = 'title'

	constructor(props) {
		super(props)
		Object.assign(this, untangleRecMap(this))
	}

	static async trainingOverviewIndex() {
		const res = await backend.get('topics/training_overview')
		handleTopicResponse(res)
	}

	static async getTraining() {
		const res = await backend.get('training')
		if (!res.ok) return

		const {items = [], done_ids = []} = res.data || {}

		if (items?.length) {
			handleTopicResponse(res)
		}

		if (done_ids?.length) {
			// mark done topics as not promptable
			handleTopicResponse({data: {items: done_ids.map(id => ({id, promptable: false}))}})
		}
	}

	static async finishTrainingStep(resource, data) {
		const {tableName, id, topicResourceId} = resource

		let res

		if (tableName === 'infos') {
			res = await backend.post(`topic_resources/${topicResourceId}/finish`, {skipSuccessNotif: true})
		}

		if (tableName === 'quizItems') {
			res = await backend.post('user_answers', {quiz_item_id: id, ...data, skipSuccessNotif: true})
		}

		if (res.ok) {
			handleTopicResponse(res)
		}

		return res
	}

	static async removeTopicResource(topicResourceId) {
		return await API.destroy('topic_resources', topicResourceId)
	}

	async publish() {
		return await super.update({published: true})
	}

	async unpublish() {
		return await super.update({published: false})
	}

	async fetchTrainingOverview() {
		await this.resourceReq('training_overview', {method: 'get'})
	}

	async createTopicPrompt(user) {
		const res = await API.create('user_topic_prompt', {topic_id: this.id, user_id: user.id}, {extraParams: {skipSuccessNotif: true}})

		if (res.ok) {
			await this.fetchTrainingOverview()
			await this.modelConfig?.createTopicPromptOnSuccess?.({res, user})
		}

		return res
	}

	async _moveResource(index, resources, direction) {
		const newIndex = index + direction
		if (newIndex < 0 || newIndex >= resources.length) return

		const newResources = _.clone(resources)
		;[newResources[index], newResources[newIndex]] = [newResources[newIndex], newResources[index]]
		const items = newResources.map((r, i) => ({id: r.topicResourceId, order: i}))
		return await API.updateMulti('topic_resources', items)
	}

	async moveResourceUp(index, resources) {
		return this._moveResource(index, resources, -1)
	}

	async moveResourceDown(index, resources) {
		return this._moveResource(index, resources, 1)
	}

	trainingType() {
		const {always_trainable, valid_untill, days_to_start} = this

		if (always_trainable) return 'always_trainable'
		if (valid_untill) return 'valid_untill'
		if (days_to_start != null) return 'days_to_start'

		return null
	}
}

export default Topic
